import { useState, useEffect } from 'react';
import { Box, CircularProgress, Typography, Button, Link, Alert } from '@mui/material';
import { ArrowBack as ArrowBackIcon, Send as SendIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import API from '@utils/axios';
import { extractBestTranslation, formatDateTime } from '@utils/helpers';
import SendoutIsTestChip from '@components/sendout/SendoutIsTestChip';

function SendoutRecapStep({ formData, onBack, onSubmit, processing }) {
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [previewData, setPreviewData] = useState(null);

    useEffect(() => {
        setLoading(true);
        API.post('/sendouts/preview', formData)
            .then(response => {
                setPreviewData(response.data);
                console.log('Preview response:', response.data);
            })
            .catch(error => {
                setError(true);
                setErrorMessage(error.response.data.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [formData]);

    return (
        <Box>
            {loading ? (
                <Box display="flex" justifyContent="center" my={4}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    {error ? (
                        <Box>
                            <Alert severity="error">
                                {t(errorMessage)}
                            </Alert>
                        </Box>
                    ) : (
                        <>
                            {previewData.warnings.length > 0 && (
                                <Box sx={{ mb: 2 }}>
                                    {previewData.warnings.map(warning => (
                                        <Alert severity="warning" key={warning}>
                                            {t(warning.message, warning.data)}
                                        </Alert>
                                    ))}
                                </Box>
                            )}
                            <SendoutIsTestChip is_test={previewData.is_test} />
                            <Typography variant="body1" component="div" sx={{ mt: 2 }}>
                                {t('The workflow')}
                                {' '}
                                <Typography component="span" fontWeight="bold">
                                    <Link href={`/workflows/${previewData.workflow.customer_id ? 'custom' : 'templates'}/${previewData.workflow.id}`} target="_blank" rel="noopener noreferrer">
                                        {extractBestTranslation(previewData.workflow.name, i18n.language)}
                                    </Link>
                                </Typography>
                                {' '}
                                {previewData.status === 'InProgress'
                                    ? t('will be executed as soon as possible')
                                    : previewData.status === 'Paused'
                                        ? t('will be created (paused)')
                                        : t('will be executed from {{date}}', { date: formatDateTime(previewData.planned_at) })
                                }
                                {' '}
                                {previewData.mailingList.count.contacts_total === 1 ? (
                                    <>
                                        {t('for the only contact of the mailing list')}
                                    </>
                                ) : (
                                    <>
                                        {t('for the {{count}} contacts of the mailing list', { count: previewData.mailingList.count.contacts_total })}
                                    </>
                                )}
                                {' '}
                                <Typography component="span" fontWeight="bold">
                                    <Link href={`/mailinglists/${previewData.mailingList.id}`} target="_blank" rel="noopener noreferrer">
                                        {previewData.mailingList.name}
                                    </Link>
                                </Typography>
                                .
                            </Typography>
                        </>
                    )}

                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>
                        <Button onClick={onBack} variant="outlined" startIcon={<ArrowBackIcon />}>
                            {t('Previous')}
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            endIcon={<SendIcon />}
                            onClick={onSubmit}
                            disabled={error}
                        >
                            {t('Validate')}
                        </Button>
                    </Box>
                </>
            )}
        </Box>
    );
}

export default SendoutRecapStep; 